import angular from 'angular';
import StateChangeComponent from './state-change.component';

export default angular
  .module('verifyApp.stateChange', [])
  .component('stateChange', StateChangeComponent)
  .name;



// WEBPACK FOOTER //
// ./client/components/state-change/index.js